import { toCamelCase } from "./utils/toCamelCase";

/**
 * Helper that converts the inline css style-attribute into a style object that
 * can be parsed by React.
 */
export function parseCss(
  cssText: string
): { [key: string]: string } | undefined {
  // ... Otherwise convert the CSS to a style object that can be parsed by the
  // browser
  const style: { [key: string]: string } = {};

  // Loop through all rules of the CSS-string
  cssText.split(";").forEach((css) => {
    // Split string in key-value pairs (skip if no value is
    // present)
    const cssParts = css.split(":");

    if (!cssParts[0].length || !css[1]) {
      return;
    }

    // Parse key and values from the individual parts of the css statement
    const key = toCamelCase(
      cssParts[0]
        // Trim whitespace
        .replace(/^\s*/, "")
        .replace(/\s*$/, "")

        // Parse vendor prefixes
        .replace(/^\-ms\-/, "ms-")
    );

    const value = cssParts
      .slice(1)
      .join(":")
      // Trim whitespace
      .replace(/^\s*/, "")
      .replace(/\s*$/, "");

    // Inject into style-object
    style[key] = value;
  });

  return style;
}
